import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { formatInteger, formatDecimal } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
require('./style.scss');

interface IProps {
	editing: boolean;
	rating?: number;
	votes?: number;
	onStarClick?: (value: number) => void;
	hideRatingNumber?: boolean;

	/* func props */
	t?: (key: string, object?: any) => string;
}

interface IState {
	userRating: null | number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class StarsRating extends React.Component<IProps, IState> {
	public state;

	constructor(props) {
		super(props);

		this.state = {
			userRating: null,
		};

		this.handleOnStarClick = this.handleOnStarClick.bind(this);
	}

	private get isEditable(): boolean {
		return this.props.editing && typeof this.props.onStarClick === 'function';
	}

	private get rating(): number | undefined {
		if (this.isEditable && this.state.userRating !== null) {
			return this.state.userRating;
		}
		return this.props.rating;
	}

	private handleOnStarClick(value: number) {
		if (this.isEditable) {
			this.props.onStarClick(value);
		}
	}

	private handleStarHover(value: number | null) {
		if (this.isEditable) {
			this.setState({
				userRating: value,
			});
		}
	}

	public render() {
		const { votes, t, hideRatingNumber } = this.props;
		const rating = this.rating || 0;
		const onLeave = () => (this.isEditable ? this.handleStarHover(null) : undefined);
		const starElementsArray: JSX.Element[] = [];

		for (let i = 0; i < 5; i++) {
			if (i < rating) {
				starElementsArray.push(
					<React.Fragment key={`star-${i}`}>{renderIcon('star1', 16, 16, 'fullStar')}</React.Fragment>,
				);
			} else {
				starElementsArray.push(
					<React.Fragment key={`star-${i}`}>{renderIcon('star1', 16, 16, 'emptyStar')}</React.Fragment>,
				);
			}
		}

		return (
			<div className="starsRatingContainer">
				<div className="starsRating">
					{rating !== null && rating !== undefined && !hideRatingNumber ? (
						<label className="rating">{formatDecimal(rating, 1)}</label>
					) : null}
					<div className="stars" onMouseLeave={onLeave}>
						{starElementsArray}
					</div>
					{votes !== null && votes !== undefined ? (
						<label className="votes">
							{t('Common_StarsRating_Label_ReviewsWithCount', { count: formatInteger(votes) })}
						</label>
					) : null}
				</div>
			</div>
		);
	}
}

export { StarsRating };
